import React, {useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import "./styles.css"

// List options
const options = [
    "Normal text", "Heading 1", "Heading 2", "Heading 3", "Heading 4", "Heading 5"
];

// Imported from MUI: https://mui.com/material-ui/react-menu/
const StylesMenu = ({editor}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const open = Boolean(anchorEl);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        if (selectedIndex == index) {
            setAnchorEl(null);
            return ;
        }
        setSelectedIndex(index);
        if (index == 0)
            editor.chain().focus().toggleHeading({level: selectedIndex}).run()
        if (index != 0)
            editor.chain().focus().toggleHeading({level: index}).run()
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className = 'List'>
            <List
                component="nav"
                sx={{ bgcolor: 'background.paper' }}
            >
                <ListItem
                    button
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickListItem}
                    sx = {{height: 10, width: 120}}
                >
                <ListItemText
                    primary={options[selectedIndex]}
                />
                </ListItem>
            </List>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {options.map((option, index) => (
            <MenuItem
                key={option}
                selected={index === selectedIndex}
                onClick={(event) => handleMenuItemClick(event, index)}
            >
                {option}
            </MenuItem>
            ))}
        </Menu>
        </div>
  );
}

export default StylesMenu;